<template>
    <div>
        <table class="table w-full">
            <thead>
                <tr>
                    <sortable-header @sort="handleSort" sort-by="id" :direction="sort_direction" :column="sort_column" class="text-left border-b-2 border-gray py-2 px-2 whitespace-nowrap">Item #</sortable-header>
                    <sortable-header @sort="handleSort" sort-by="title" :direction="sort_direction" :column="sort_column" class="text-left border-b-2 border-gray py-2 px-2">Product</sortable-header>
                    <sortable-header @sort="handleSort" sort-by="shorted_quantity" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2">Shorted</sortable-header>
                </tr>
            </thead>
            <tbody>
                <tr v-for="product in data" :key="product.id">
                    <td>{{ product.id }}</td>
                    <td>
                        {{ product.title }}
                        <span v-if="product.description"> - {{ product.description }}</span>
                        <span v-if="product.size"> - {{ product.size }}</span>
                    </td>
                    <td class="text-right">
                        {{ product.shorted_quantity }}
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td class=""></td>
                    <td class="text-right">Total:</td>
                    <td class="text-right">{{ totalTotal }}</td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
import SortableHeader from '@/Shared/SortableHeader';

export default {
    components: {
        SortableHeader,
    },

    props: ['data', 'sort_column', 'sort_direction'],
    emits: ['sort'],

    methods: {
        handleSort (sort) {
            this.$emit('sort', sort);
        },
    },

    computed: {
        totalTotal() {
            return this.data.reduce(function(accumulator, currentValue){
                return accumulator + Number(currentValue.shorted_quantity);
            }, 0);
        },
    }

}
</script>

<style scoped>
    .bg-logo {
        background: #efefef;
    }

    .brand {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .brand img {
        max-height: 38px;
    }

    .brand a {
        line-height: 1;
        font-size: 14px;
    }
</style>